// src/com/auto_com_veh_info/AutoComVehInfoDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    dcCd : {
		id: 'dcCd', label: '물류센터',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // varchar(3)
    comId : {
		id: 'comId', label: '운송사',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // varchar(10)
    vehTypeId : {
		id: 'vehTypeId', label: '차종',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
        labelKey: 'vehTypeName',
	}, // varchar(10)
    vehTypeAlias : {
		id: 'vehTypeAlias', label: '차종별칭',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    vehRent : { id: 'vehRent', label: '용차구분', }, // tinyint(1)
    vehPtCapa : { id: 'vehPtCapa', label: 'CAPA', }, // int(11)
    comName : { id: 'comName', label: '운송사' }, // varchar(30)
    vehTypeName : { id: 'vehTypeName', label: '차종', }, // varchar(50)
    /* rentType : {
		id: 'rentType', label: 'rentType',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '7자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 7)},
	}, // enum('no_rent','rent1','rent2') */
    dcName : { id: 'dcName', label: '물류센터', }, // varchar(20)
    /* dcTypeCd : {
		id: 'dcTypeCd', label: 'dcTypeCd',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, // enum('A','F','E') */
    
};

/**
 * AUTO_COM_VEH_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-10-22 15:56:57 using DbdbTap
 */
export const AutoComVehInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '운송사 차종 등록 오류',
        Edit: '운송사 차종 수정 오류',
        Remove: '운송사 차종 삭제 오류',
        Get: '운송사 차종 조회 오류',
    },
    tableProps: {
        tableId: 'autoComVehInfoTable',
        uniqueKey: 'key', // dcCd_comId_vehTypeId
        getKey: (item) => {return item.dcCd+'_'+item.comId+'_'+item.vehTypeId},
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'comId', label: Dict.comId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: Dict.comName.label, width: 130, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeId', label: '차종코드', width: 60, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeAlias', label: Dict.vehTypeAlias.label, width: 90, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehRent', label: Dict.vehRent.label, width: 90, show: true, option:{align: 'center', print:(r,i,v)=>v?'용차':'고정차'} },
            { id: 'vehPtCapa', label: Dict.vehPtCapa.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            // { id: 'rentType', label: Dict.rentType.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'dcName', label: Dict.dcName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'dcTypeCd', label: Dict.dcTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'inherit', print:(r,i,v)=>v?v.substring(0,16):'-'} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
